import { render } from "./personalization.vue?vue&type=template&id=5881b62a"
import script from "./personalization.vue?vue&type=script&lang=js"
export * from "./personalization.vue?vue&type=script&lang=js"

import "./personalization.vue?vue&type=style&index=0&id=5881b62a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__